import { render, staticRenderFns } from "./note_preview_widget.vue?vue&type=template&id=6365afec&scoped=true"
import script from "./note_preview_widget.vue?vue&type=script&lang=js"
export * from "./note_preview_widget.vue?vue&type=script&lang=js"
import style0 from "./note_preview_widget.vue?vue&type=style&index=0&id=6365afec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365afec",
  null
  
)

export default component.exports